"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.handleIERenderingIssues = handleIERenderingIssues;

/**
 * IE11 creates new stack for z-index if positioned.
 * So explicitly making the outermost modal container positioned fixed to solve nested modal issue
 */
function handleIERenderingIssues(modalDialog) {
  try {
    var el = modalDialog.parentElement.parentElement;

    if (el instanceof HTMLElement) {
      el.style.position = "fixed";
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
}